import { AppNotificationCategory } from './appNotifications';

export enum NotificationOrigin {
  alarms = 'alarms',
  safeGpt = 'safeGpt',
}

export interface NotificationConfig {
  notificationType: number;
  email: string[];
  sms: string[];
  notificationDescription?: string;
  push: boolean;
  playSound: boolean;
  days: {
    day: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    endHour?: number;
    startHour?: number;
    allDay: boolean;
  }[];
  origin: NotificationOrigin;
  category: AppNotificationCategory;
  categoryDisplay: string;
}
